__webpack_require__.p = "/courses/";